import styled from 'styled-components';

const DescriptionTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export default DescriptionTitle;
